import React from 'react';
import { Box, Typography, Button, Modal } from '@mui/material';
import { tokens, withAlpha } from '../../Common/designTokens';

/**
 * Informative modal for showing attention/info messages
 */
const InformativeModal = ({
  open,
  message,
  onClose,
  title = "Attention", // Default title  
  onConfirm, // <-- add optional onConfirm
  showCancel = false, // <-- add showCancel prop
}) => {
  // Ok button handler
  const handleOk = () => {
    if (onConfirm) {
      onConfirm();
    } else if (onClose) {
      onClose();
    }
  };
  // Cancel button handler
  const handleCancel = () => {
    if (onClose) {
      onClose();
    }
  };  
  // Common modal style
  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 520,
    bgcolor: tokens.colors.bodyBackgroundColor,
    border: `1px solid ${tokens.colors.bodyBorderColor50}`,
    boxShadow: 24,
    p: 4,
    borderRadius: "8px",
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  };

  const messageBodyBaseStyle = {
    color: tokens.colors.fontColour85,
    mb: 3,
    p: 0,
  };

  const renderMessageContent = () => {
    if (!message) return null;
    if (typeof message === "string" || typeof message === "number") {
      return (
        <Typography sx={{ ...messageBodyBaseStyle, textAlign: "center" }}>
          {message}
        </Typography>
      );
    }
    return (
      <Box sx={{ ...messageBodyBaseStyle, textAlign: "left", width: "100%" }}>
        {message}
      </Box>
    );
  };

  return (
    <Modal
      open={open}
      onClose={handleCancel}
      aria-labelledby="informative-modal"
    >
      <Box sx={modalStyle}>
        <Typography id="informative-modal-title" variant="h6" component="h2" sx={{ color: tokens.colors.fontColour, mb: 2, textAlign: 'center', fontWeight: 'bold' }}>
          {title}
        </Typography>
        {renderMessageContent()}
        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
          <Button
            variant="contained"
            onClick={handleOk}
            sx={{
              textTransform: "none",
              fontWeight: "700",
              backgroundColor: tokens.palette.primary,
              '&:hover': { backgroundColor: tokens.palette.primaryA80 },
              width: '140px',
              color: tokens.colors.white,
              borderRadius: "8px",
            }}
          >
            Ok
          </Button>
          {showCancel && (
            <Button
              variant="outlined"
              onClick={handleCancel}
              sx={{
                textTransform: "none",
                fontWeight: "700",
                color: tokens.colors.fontColour,
                borderColor: tokens.colors.bodyBorderColor50,
                '&:hover': {
                  borderColor: tokens.colors.bodyBorderColor50,
                  backgroundColor: tokens.colors.defaultGridHoverColor,
                },
                width: '140px'
              }}
            >
              Cancel
            </Button>
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default InformativeModal;